import React, { useEffect } from 'react';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { useUser } from 'apps/sigma2-ui/src/state/user';

const redirectToHomepage = () => {
  if (['https://www.sigma2.io', 'https://sigma2.io'].indexOf(origin) !== -1) {
    document.location = `https://www.sigmasquared.io`;
  } else {
    document.location = `https://www.sigmasquared.io/?loginHostname=${origin}`;
  }
};

// Redirect to the marketing site and attach the origin so we can easily navigate back to the login page.
export const HomeRedirect = () => {
  const { myUser, myUserStatus } = useUser();
  const navigate = useNavigateSafe();

  // TODO: This is a duplicate of code in ResetPasswordPage, let's make it a common hook if possible.
  useEffect(() => {
    if (!myUserStatus || myUserStatus === 'logging_in') {
      return;
    }

    if (myUserStatus === 'logged_out') {
      redirectToHomepage();
      return;
    }

    if (myUser && myUser.roleAssignments === 'superAdmin') {
      navigate('/admin');
      return;
    }

    navigate('/overview');
  }, [myUser, myUserStatus, navigate]);

  return <></>;
};
